module.exports = __webpack_public_path__ + "img/HeavierThan5kg.650d6fc5.svg";